import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccOfferedSeatCountsPart } from '../../../acc-offered-seat-counts/acc-offered-seat-counts.part';


@Component({
	selector: 'admissions-prospects-tab-2-part',
	standalone: true,
	imports: [AccOfferedSeatCountsPart],
	templateUrl: './admissions-prospects-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class AdmissionsProspectsTab2Part {
}
